
import logo from '../assets/followgreen-app-logo.svg';

import headerimg from '../assets/cities/city-ampelokipi-menemeni.svg';
import logo_dimos_voulas from '../assets/logo_dimos_voulas.png';
import kathara_mazi from '../assets/kathara_mazi.png';
// import Awards from '../components/Awards';
import { Suspense } from 'react';
// import Earn from './Earn';
import { BsRecordCircleFill } from "react-icons/bs";
// import Schools from './Schools';
import SingleRowSlider from '../components/SingleRowSlider';
import Login from '../components/Login';
import useAuth from '../hooks/useAuth';
import { Navigate, useNavigate } from 'react-router-dom';
import { replace } from 'formik';
// import { createPath } from 'react-router-dom';

// import { getAllData } from '../api';



const colors =
{
    app_brown: '#f07e64',
    app_red: '#e35972',
    app_green: '#6fa84a',
    app_green_light: '#93BC78',
    app_yellow: '#f2c237',
    app_blue: '#49a3d4',
    app_blue_dark: '#136492',
    app_dark_green: '#098C5E',
}

function HomePage() {

    const navigate = useNavigate();

    const { login,isAuthenticated, user, logout } = useAuth();

    if(isAuthenticated){
       return <Navigate replace to="/select" />;
    }


    return (
        <div className="flex flex-col justify-between bg-white ">
            {/* max-w-[1200px] */}
            {/* <svg className='absolute' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none"><path fill={colors.app_blue} fill-opacity="1" d="M0,0V65.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,65.23V0Z"></path></svg> */}
            <div className="flex content-center self-center justify-center w-full pt-10 pb-10 overflow-hidden rounded-b-[100%] bg-gradient-to-r from-app_green to-app_blue" >

                <a href="/">
                    <img
                        src={logo_dimos_voulas}
                        width={230}

                        alt="Float UI logo"
                    />
                </a>
                <a href="/" className=''> 
                    <img
                        src={kathara_mazi}
                        width={128}

                        alt="Float UI logo"
                    />
                </a>
            </div>
            
           <div className='flex flex-col pt-10 pb-16'>
             <div className="flex flex-col items-center" >
            
                <h1 className="pt-10 text-4xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-app_green to-app_blue">
                    Διαλογή στην Πηγή
                </h1>
                <h2 className="text-2xl font-semibold leading-relaxed text-transparent bg-clip-text bg-gradient-to-r from-app_green to-app_blue ">
                    Κερδίζω όσο Διαχωρίζω
                </h2>
                <h3 className="pt-5 pb-5 text-xl font-semibold text-app_green_light">
                Ανακάλυψε όλες τις συμμετοχές στα προγράμματα Διαλογής στην Πηγή 
                </h3>
                
            </div>

            <Login  ></Login>
           </div>




            

            {/* <div className="container flex mx-auto mt-3 justify-evenly " >
               <img src={headerimg} alt=""></img>
            </div> */}
            {/* <div className='items-center justify-between px-4 mx-auto lg:flex lg:px-0 max-w-[1200px] -mb-5 mt-10 '>
                <button type="button" className="text-white bg-gradient-to-r from-app_yellow via-app_brown to-app_red hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-bold rounded-full text-2xl px-10 py-4 text-center">Τα σχολεία μας</button>
                <button type="button" className="shadow-lg shadow-gray-300 bg-white hover:bg-gradient-to-br drop-shadow-md hover:shadow-md text-app_brown font-semibold rounded-full text-md px-5 text-center h-11 ">
                    <div className='flex items-center'><BsRecordCircleFill></BsRecordCircleFill>
                        <p className='pl-1.5 pb-0.5'>{'περισσοτερα'.toUpperCase()}</p></div>
                </button>

            </div> */}


            {/* Schools Section */}
            {/* <Schools></Schools> */}

            {/* Stats Section */}
            {/* <div className='flex flex-col px-4 mx-auto lg:px-0 max-w-[1200px] -mb-5 mt-10 items-center'>
                <h2 className="text-3xl font-bold text-gray-700 ">Στατιστικά</h2>
                <div className="w-2/12 h-1 bg-gradient-to-r from-orange-400 via-red-500 to-pink-500">
                </div>
                <p className="text-lg font-normal text-gray-700">Το followgreen επιβραβεύει την ανακύκλωση & ευαισθητοποιεί</p>

                <div className='flex pt-6'>
                    <div className="mr-2 p-6 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
                        <a href="#">
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Noteworthy technology acquisitions 2021</h5>
                        </a>
                        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.</p>
                        <a href="#" className="inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            Read more
                            <svg className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        </a>
                    </div>
                    <div className="p-6 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
                        <a href="#">
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Noteworthy technology acquisitions 2021</h5>
                        </a>
                        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.</p>
                       
                    </div>
                    <div className="ml-2 p-6 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700">
                        <a href="#">
                            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Noteworthy technology acquisitions 2021</h5>
                        </a>
                        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">Here are the biggest enterprise technology acquisitions of 2021 so far, in reverse chronological order.</p>
                        
                    </div>
                </div>

            </div> */}


            {/* Earn Section */}

            {/* <Earn></Earn> */}

            <div className="bottom-0 w-full h-5 lg:fixed bg-gradient-to-r from-app_green to-app_blue">
                    
                
            </div>




            {/* <Awards></Awards> */}
            {/* <h4 className="underline bg-green-500">Κατέβασε το Followgreen App δωρεάν</h4> */}

        </div>
    );
}

export default HomePage;
